module.exports = __webpack_public_path__ + "img/person-1.91f02815.png";